import Raven from 'raven-js';
import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { evaluateInAppV2Rpc } from '../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export const fetchPurchaseMotions = async ({
  location,
  apiName
}) => {
  try {
    var _response$purchaseMot;
    const response = await rpcClient.call(evaluateInAppV2Rpc, {
      request: {
        locations: [location],
        productApiNames: [apiName]
      }
    });
    return ((_response$purchaseMot = response.purchaseMotionsMapping.productsByLocationString[location]) === null || _response$purchaseMot === void 0 || (_response$purchaseMot = _response$purchaseMot.purchaseMotionsByProductApiName[apiName]) === null || _response$purchaseMot === void 0 ? void 0 : _response$purchaseMot.purchaseMotions.filter(isPurchaseMotion)) || [];
  } catch (e) {
    Raven.captureException(e instanceof Error ? e : new Error(String(e)));
    throw e;
  }
};
function isPurchaseMotion(value) {
  return typeof value === 'string';
}